exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".homePage .card{background-color:hsla(0,0%,100%,.9);max-width:90%;width:90%;font-size:1.5em;padding:50px}.homePage .mainPage{width:100%;text-align:center;padding-bottom:100px;overflow:hidden}.homePage #appContainerWrapper{overflow:auto;margin-top:50px}.homePage .appItem{background:#041e47;border-radius:1rem;width:200px;height:200px;color:#fff;font-size:24px;margin:0 30px;padding:10px}.homePage .appDisabled{background:#d3d3d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/home.scss
// module id = 480
// module chunks = 0